var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_1435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7821 14.8319C10.3355 14.8324 9.97298 14.4709 9.97241 14.0243C9.97217 13.825 10.0455 13.6327 10.1783 13.4841L15.1595 7.89272C15.4572 7.55926 15.9689 7.5303 16.3024 7.82803C16.6358 8.12575 16.6648 8.63743 16.3671 8.97089L11.3859 14.5623C11.2323 14.7342 11.0126 14.8323 10.7821 14.8319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1613 5.14871C24.0747 4.86308 23.8382 4.64813 23.5456 4.58912L20.2615 3.9336L19.606 0.653771C19.5204 0.215475 19.0956 -0.0704873 18.6573 0.0151135C18.4996 0.0459069 18.3547 0.122972 18.241 0.236508L14.4286 4.04893C14.2376 4.24002 14.1547 4.51389 14.2076 4.77886L14.9698 8.59022C15.0337 8.91082 15.2843 9.16141 15.6049 9.22529L19.4163 9.98757C19.4685 9.99794 19.5215 10.003 19.5748 10.0027C19.7893 10.0027 19.9951 9.91781 20.1473 9.76654L23.9586 5.95412C24.1695 5.74363 24.2475 5.43402 24.1613 5.14871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8251 14.0232C14.8251 16.2562 13.0149 18.0664 10.7819 18.0664C8.54897 18.0664 6.73877 16.2562 6.73877 14.0232C6.73877 11.7902 8.54897 9.98005 10.7819 9.98005C11.1284 9.97666 11.4734 10.0239 11.8062 10.1202L9.36952 12.7725C8.66618 13.5414 8.71931 14.7349 9.4882 15.4382C10.2571 16.1416 11.4506 16.0885 12.1539 15.3196C12.1676 15.3046 12.1811 15.2893 12.1944 15.2739L14.5879 12.6755C14.7442 13.1077 14.8245 13.5636 14.8251 14.0232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.27 10.9504C20.0502 11.0368 19.8161 11.0807 19.58 11.0798C19.4535 11.0798 19.3272 11.0689 19.2026 11.0475L16.4748 10.4976L15.7524 11.3278C16.2082 12.1528 16.4457 13.0806 16.4425 14.0232C16.4425 17.1494 13.9082 19.6837 10.782 19.6837C7.65584 19.6837 5.12159 17.1494 5.12159 14.0232C5.12159 10.897 7.65584 8.36279 10.782 8.36279C11.5259 8.36099 12.2626 8.50761 12.9492 8.79406L13.7254 7.89917L13.154 4.98809C13.1092 4.77172 13.1019 4.54926 13.1325 4.3304C7.77913 3.03173 2.38657 6.31866 1.08789 11.672C-0.21078 17.0253 3.07615 22.4179 8.42947 23.7165C13.7828 25.0152 19.1754 21.7283 20.474 16.375C20.9089 14.5827 20.8382 12.7049 20.27 10.9504Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_1435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMission);
export default __webpack_public_path__ + "static/media/icon-mission.457aa4f0b27e7cd42640928491d5a4fa.svg";
export { ForwardRef as ReactComponent };